module.exports = __webpack_public_path__ + "static/media/shuttleComfortIcon.90bf8490.png";